import Vue from "vue";
import Router from "vue-router";
import Locations from "@/components/Locations";
import Offices from "@/components/Offices";
import Calendar from "@/components/calendar/Calendar";
import Signup from "@/components/auth/Signup";
import EmailLink from "@/components/auth/EmailLink";
import Finishsignup from "@/components/auth/FinishSignup";
import Profile from "@/components/profile/Profile";
import Approve from "@/components/approve/Approve";
import MyBookings from "@/components/bookings/MyBookings";
import AllBookings from "@/components/bookings/AllBookings";
import AllUnapproved from "@/components/bookings/allAwaitingApproval";
import AllOffices from "@/components/offices/allOffices";
import Admin from "@/components/admin/Admin";
import firebase from "firebase";
import db from "@/firebase/init";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Locations",
      component: Locations,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/location/:locationname",
      name: "Offices",
      component: Offices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/approve/:bookingid/:officeid/:status",
      name: "Approve",
      component: Approve,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/calendar/:officeid/:locationname",
      name: "Calendar",
      component: Calendar,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/mybookings",
      name: "MyBookings",
      component: MyBookings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/allbookings",
      name: "AllBookings",
      component: AllBookings,
      meta: {
        requiresSecretaryPermission: true
      }
    },
    {
      path: "/allunapproved",
      name: "AllUnapproved",
      component: AllUnapproved,
      meta: {
        requiresSecretaryPermission: true
      }
    },
    {
      path: "/allusers",
      name: "Admin",
      component: Admin,
      meta: {
        requiresAdminPermission: true
      }
    },
    {
      path: "/alloffices",
      name: "AllOffices",
      component: AllOffices,
      meta: {
        requiresAdminPermission: true
      }
    },
    {
      path: "/signup",
      name: "Signup",
      component: Signup,
      meta: {
        requiresNotAuth: true
      }
    },
    {
      path: "/emaillink",
      name: "EmailLink",
      component: EmailLink
    },
    {
      path: "/finishsignup",
      name: "FinishSignup",
      component: Finishsignup
    },
    {
      path: "*",
      name: "Signup",
      component: Signup
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
 
router.beforeEach(async (to, from, next) => {

  //check to see if route requires auth
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    //check Auth State of User
    let user = firebase.auth().currentUser;
    if (user) {
      //user signed in
      next();
    } else {
      //no user signed in
      next({ name: "Signup" });
    }

  } else if (to.matched.some(rec => rec.meta.requiresNotAuth)) {

    //check Auth State of User
    let user = firebase.auth().currentUser;
    console.log(user)
    if (user) {
      // next({ name: "Offices" });
      next({ name: "Locations" });
    } else {
      next();
    }

  } else if (to.matched.some(rec => rec.meta.requiresSecretaryPermission)) {
    
    //check Auth State of User
    let user = firebase.auth().currentUser;
    if (user) {
               
        var collection = db.collection('users').where("email", "==", user.email);
        const answer = await collection.get();

        // console.log(answer)
        answer.forEach(doc => {
            console.log(doc.data())
            if(doc.data().oldEmail){
                user.old_email = doc.data().oldEmail;
            } else {
                user.old_email = null;
            }
        });

        var userdb = null;
        var collection = null;

        if(user.old_email){
            console.log("User has an old email address: " + user.old_email)
            var collection = db.collection('users').where("oldEmail", "==", user.old_email)
        } else {
            console.log("User does not have an old email address.")
            var collection = db.collection('users').where("user_id", "==", user.uid)
        }

      var data = await collection.get();
      data.forEach(doc => {
        userdb = doc.data();
        if (userdb.permission > 100) {
          console.log("is secretary");
          next();
        } else {
          console.log("is consultant");
          // next({ name: "Offices" });
          next({ name: "Locations" });
        }
      });
    } else {
      next({ name: "Signup" });
    }
  } else if (to.matched.some(rec => rec.meta.requiresAdminPermission)) {
    //check Auth State of User
    let user = firebase.auth().currentUser;
        if (user) {
               
        var collection = db.collection('users').where("email", "==", user.email);
        const answer = await collection.get();

        // console.log(answer)
        answer.forEach(doc => {
            console.log(doc.data())
            if(doc.data().oldEmail){
                user.old_email = doc.data().oldEmail;
            } else {
                user.old_email = null;
            }
        });

        var userdb = null;
        var collection = null;

        if(user.old_email){
            console.log("User has an old email address: " + user.old_email)
            var collection = db.collection('users').where("oldEmail", "==", user.old_email)
        } else {
            console.log("User does not have an old email address.")
            var collection = db.collection('users').where("user_id", "==", user.uid)
        }

      var data = await collection.get();
      data.forEach(doc => {
        userdb = doc.data();
        if (userdb.permission > 200) {
          console.log("is admin");
          next();
        } else {
          console.log("is consultant");
          // next({ name: "Offices" });
          next({ name: "Locations" });
        }
      });
    } else {
      next({ name: "Signup" });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js